function lovedPhrasesRender() {
    var json = JSON.parse(localStorage.getItem('lovedPhrases'));
  console.log('loved phrases render');
    if (json) {
      console.log('render phrases length: ',json.length);
      var ulElem = $('#fav_block_content').find('.view-psukim-phrases').find('.view-content').find('ul');
      ulElem.empty();
      for (const elem of json) {
        
        var li = $(`<li class="views-row views-row-2 views-row-even phrase" data-id="${elem.phraseId}"></li>`);

        var phraseVid;
        if (elem.phraseVid) {
          phraseVid = $('<div class="vid"></div>');
        
          phraseVid.append(elem.phraseVid);
        }
        
        var phraseEng = $('<div class="phrase_eng"></div>');
        phraseEng.append(elem.phraseEng);

        var phraseHeb = $('<div class="phrase_heb"></div>');
        phraseHeb.append(elem.phraseHeb);

        var phraseTag;
if (elem.phraseTag) {
        phraseTag = $('<div class="phrase_tag"></div>');
        
          phraseTag.append(elem.phraseTag);
}
        
        var phraseClean = $('<div class="phrase_clean"></div>');
        phraseClean.append(elem.phraseClean);

        var phraseWordCount = $('<div class="phrase_word_count"></div>');
        phraseWordCount.append(elem.phraseWordCount);

        var wishlistBtn = $('<div class="add2loved"><span class="flag-wrapper flag-fav-phrase flag-fav-phrase-1101"><a href="#" title="" class="flag-phrase unflag-action" rel="nofollow">u</a><span class="flag-throbber">&nbsp;</span></span></div>');

            
        li.append(phraseEng);
        if (elem.phraseVid)
            li.append(phraseVid);
        li.append(phraseHeb);
        if (elem.phraseTag)
          li.append(phraseTag);
        li.append(phraseClean);
        li.append(phraseWordCount);
        li.append(wishlistBtn);
        ulElem.append(li);
      }
      $('.loved_counter').text($('#fav_block_content li').length);
    }
}

function lovedPhrasesUpdateCount() {
  if ($('.loved_counter')) {
  var json = JSON.parse(localStorage.getItem('lovedPhrases'));
  var count = 0;
  if (json) {
    count = json.length;
  }
  $('.loved_counter').text(count);
  }
}

function lovedPhrasesAdd(id, phraseEng, phraseHeb, phraseTag, phraseClean, phraseWordCount, vid) {
  console.log('add new loved phrase id', id);
  var json = JSON.parse(localStorage.getItem('lovedPhrases'));
      if (!json) {
        json = new Array();
      }
    if (json.find(e => e.phraseId == id) == undefined) {
      console.log('adding to local storage');
      json.push({phraseId: id, phraseEng:phraseEng, phraseHeb:phraseHeb, phraseTag: phraseTag, 
                phraseClean: phraseClean,phraseWordCount: phraseWordCount, phraseVid: vid})
      localStorage.setItem('lovedPhrases', JSON.stringify(json));
  }
}

function lovedPhrasesExists(id) {
  var json = JSON.parse(localStorage.getItem('lovedPhrases'));
      if (json) {
         return json.find(e => e.phraseId == id) != undefined;
      }
}

function lovedPhrasesRemove(id) {
  var json = JSON.parse(localStorage.getItem('lovedPhrases'));
  console.log('remove phrase id:',id);
      if (json) {
         if (json.find(e => e.phraseId == id) != undefined) {
           var toRemove = $('#phrases_block_content').find(`.phrase[id="${id}"]`);
           console.log('to remove: ', toRemove);
           if (toRemove) {
            var flag = toRemove.find('.add2loved').find('a');
             if (flag) {
               flag.removeClass('unflag-action');
               flag.addClass('flag-action');
             }
           }
          json = json.filter(e => e.phraseId != id);
      localStorage.setItem('lovedPhrases', JSON.stringify(json));
         }
      }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

async function fetchQuoteCategoryNames() {
  const catResponse = await fetch('/apps/back-office/api/get_quotecategorynames').then(r => r.json());
  //console.log(catResponse);
  var categories = catResponse.map(i => i.name);                   
  var selector = document.querySelector('#phrases_family_list .category-list .view-content .item-list ul');
  if (selector) {
    var first = true;
    for (var cat of categories) {
      var liDom = document.createElement('li');
      if (first) {
        first = false;
        liDom.classList.add('active');
      }
      liDom.classList.add('views-row');
      liDom.classList.add('phrase-family-b');
      liDom.innerHTML = `${cat}`;
      selector.appendChild(liDom);
    }
  }
  return categories;
}

async function fetchQuoteCategoryAll() {
  var categories = await fetchQuoteCategoryNames();
  //var categories = ["Blessing, Protection & Strength", "Family & Friendship", "Love & Happiness", "Life & Faith", "God & Man", "Jerusalem & Israel", "Shir Hashirim", "Eshet Chayil", "#smartSaying", "Events"];
  var number_of_phrases = 0;
  for (category of categories) {
    //console.log('category:',category);
  const rawResponse = await fetch(`/apps/back-office/api/get_quotecategory?`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({category:category})
  }).then((r) => r.json());
    
  //console.log(rawResponse);
  var container = document.getElementById('psukim_phrases_family_container');
  var familyWrapper = document.createElement('div');
    familyWrapper.classList.add('phrase_family_wrapper');
    var ulElem = document.createElement('ul');
    //console.log(rawResponse);
    for (item of rawResponse) {
        var liElem = document.createElement('li');
      liElem.setAttribute('data-id', item.id);
        liElem.classList.add('views-row');
      liElem.classList.add('views-row-2');
      liElem.classList.add('views-row-even');
      liElem.classList.add('phrase');
      var vidHtml = item.vid ? `<div class="vid">        
                            <div>${item.vid}</div>  
                          </div>` : '';
      var tagHtml = item.phraseTag ? `<div class="phrase_tag">${capitalizeFirstLetter(item.phraseTag)}</div>` : '';
      var flagAction = lovedPhrasesExists(item.id) ? 'unflag-action' : 'flag-action';
      liElem.innerHTML = `
                          
                          <div class="phrase_eng">
                            <p> ${item.phraseEng} </p>
                          </div>
                          ${vidHtml}
                          <div class="phrase_heb">
                            <p>${item.phraseHeb}</p>
                          </div>
                          ${tagHtml}
                          <div class="phrase_clean">
                            <p>${item.phraseClean}</p>
                          </div>
                          <div class="phrase_word_count"> ${ item.phraseWordCount } </div>
                          <div class="add2loved">
                            <span class="flag-wrapper flag-fav-phrase flag-fav-phrase-1101">
                              <a href="#" title="" class="flag ${flagAction} flag-link-toggle flag-anonymous-processed flag-processed" rel="nofollow">f</a>
                            </span>
                          </div>`;
      ulElem.appendChild(liElem);
    }
    familyWrapper.innerHTML = `<h3>${category}</h3>`;
    familyWrapper.appendChild(ulElem);
    container.appendChild(familyWrapper);
    number_of_phrases = number_of_phrases + rawResponse.length;
    $('#phrases_title').text('Psukim & Phrases (' + number_of_phrases + ')');

 

    var number_of_fit = 0;
    var front_or_back;
				if ($('body').hasClass('front')) {
					front_or_back = 'front';
				} else {
					front_or_back = 'back';
				}

				// set body class
                var phrases_or_names = 'phrases';

				// count each phrase number of letters and if there's room, add 1 to number_of_fit
				var front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
				$('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
					if ($(this).text() <= front_back_2go) {
						number_of_fit++;
						//console.log($(this).text());
					} else {
					}
				});

				//console.log('front_back_2go: '+front_back_2go+ 'number_of_fit: ' +number_of_fit );

				// update number of phrases that fit
				$('#filter_fit .filter_count').text(number_of_fit);

				// update number of total phrases
				if ($('body').hasClass('phrase_block')) {
					$('#filter_all .filter_count').text($('#phrases_block_content .phrase_word_count').length);
				} else if ($('body').hasClass('names_block')) {
					$('#filter_all .filter_count').text($('#names_block_content .phrase_word_count').length);
				}else{
                    $('#filter_all .filter_count').text($('#fav_block_content .phrase_word_count').length);
                }
  }
}

const lettersMap = ["א",
"ב",
"ג",
"ד",
"ה",
"ו",
"ז",
"ח",
"ט",
"י",
"כ",
"ל",
"מ",
"נ",
"ס",
"ע",
"פ",
"צ",
"ק",
"ר",
"ש",
"ת"];

function getLetterFromIndex(index) {
  if (index >= 0 && index < lettersMap.length) {
    return lettersMap[index];
  }
  else return lettersMap[0];
}

function quoteLetterSortIndex(value) {
  const text = String(value).trim().replace(/[ךםןףץ]/g, (letter) => ({ך:'כ',ם:'מ',ן:'נ',ף:'פ',ץ:'צ'}[letter]));
  const letterIndex = lettersMap.indexOf(text);
  if (letterIndex >= 0) return letterIndex;
  const taxonomyIndex = Number(value) - 16;
  return Number.isInteger(taxonomyIndex) && taxonomyIndex >= 0 && taxonomyIndex < lettersMap.length ? taxonomyIndex : lettersMap.length;
}

function sortQuoteLetters(rows) {
  return rows.slice().sort((first, second) =>
    quoteLetterSortIndex(first.field_last_letter_tid) - quoteLetterSortIndex(second.field_last_letter_tid)
  );
}

// Reversible display-only suppression of four reviewed equivalent pairs.
// Keep both whenever content or classification changes; stored favorites are untouched.
function filterReviewedQuoteDuplicates(rows) {
  const byId = new Map(rows.map((row) => [Number(row.id), row]));
  const reviewedPairs = [[77, 402], [184, 275], [230, 347], [246, 269]];
  const exactFields = ['phraseEng', 'phraseClean', 'phraseTag', 'phraseWordCount', 'vid', 'field_first_letter_tid', 'field_last_letter_tid'];
  const normalizedHebrew = (value) => String(value || '').replace(/<[^>]*>/g, ' ').replace(/[\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, '').replace(/[(),]/g, '').replace(/\s+/g, ' ').trim();
  const hiddenIds = new Set();
  for (const [retainedId, duplicateId] of reviewedPairs) {
    const retained = byId.get(retainedId), duplicate = byId.get(duplicateId);
    if (retained && duplicate && exactFields.every((field) => retained[field] === duplicate[field]) && normalizedHebrew(retained.phraseHeb) === normalizedHebrew(duplicate.phraseHeb)) hiddenIds.add(duplicateId);
  }
  return rows.filter((row) => !hiddenIds.has(Number(row.id)));
}

let quoteLetterRequestGeneration = 0;

function fetchQuoteLetter(my_index) {
          const requestGeneration = ++quoteLetterRequestGeneration;
          const index = Number(my_index);
          if (!Number.isInteger(index) || index < 0 || index >= lettersMap.length) return Promise.resolve([]);
          var container = document.getElementById('names_block_content');
          if (!container) return Promise.resolve([]);
          container.querySelectorAll('[id="view-content-names-wrapper"]').forEach((wrapper) => wrapper.remove());
          container.setAttribute('aria-busy', 'true');
          const rawResponse = fetch(`/apps/back-office/api/get_quoteletter?`+ new URLSearchParams({ shop: 'hadeyasshop.myshopify.com', first_letter_tid: index+16 })).then((response) => {
              if (!response.ok) throw new Error('Unable to load name verses');
              return response.json();
            }).then((r) => {
            if (requestGeneration !== quoteLetterRequestGeneration || !container.isConnected) return [];
            if (!Array.isArray(r)) throw new Error('Invalid name verses response');
            r = sortQuoteLetters(filterReviewedQuoteDuplicates(r.filter((item) => quoteLetterSortIndex(item.field_first_letter_tid) === index)));
            var familyWrapper = document.createElement('div');
    familyWrapper.classList.add('view-content');
    var ulElem = document.createElement('ul');
    for (const item of r) {
      var firstLetterIndex = quoteLetterSortIndex(item.field_first_letter_tid);
      var lastLetterIndex = quoteLetterSortIndex(item.field_last_letter_tid);
        var liElem = document.createElement('li');
        liElem.classList.add('views-row');
      liElem.classList.add('views-row-2');
      liElem.classList.add('views-row-even');
      liElem.classList.add('phrase');
      liElem.setAttribute('data-id', 'n'+item.id);
      liElem.setAttribute('isname', true);
      var vidHtml = item.vid ? `<div class="vid">        
                            <div>${item.vid}</div>  
                          </div>` : '';
      var tagHtml = item.phraseTag ? `<div class="phrase_tag">${capitalizeFirstLetter(item.phraseTag)}</div>` : '';
      var flagAction = lovedPhrasesExists('n'+item.id) ? 'unflag-action' : 'flag-action';
      liElem.innerHTML = `
                          <div class="phrase_letters">${getLetterFromIndex(firstLetterIndex)}...${getLetterFromIndex(lastLetterIndex)}</div>
                          <div class="phrase_eng">
                            <p> ${item.phraseEng} </p>
                          </div>
                          ${vidHtml}
                          <div class="phrase_heb">
                            <p>${item.phraseHeb}</p>
                          </div>
                          ${tagHtml}
                          <div class="phrase_clean">
                            <p>${item.phraseClean}</p>
                          </div>
                          <div class="phrase_word_count"> ${ item.phraseWordCount } </div>
                          <div class="add2loved">
                            <span class="flag-wrapper flag-fav-phrase flag-fav-phrase-1101">
                              <a href="#" title="" class="flag ${flagAction} flag-link-toggle flag-anonymous-processed flag-processed" rel="nofollow">f</a>
                            </span>
                          </div>`;
      ulElem.appendChild(liElem);
    }
    familyWrapper.appendChild(ulElem);
          var container2 = document.createElement('div');
            container2.id = 'view-content-names-wrapper';
          container2.appendChild(familyWrapper);
    container.querySelectorAll('[id="view-content-names-wrapper"]').forEach((wrapper) => wrapper.remove());
    container.appendChild(container2);
    container.setAttribute('aria-busy', 'false');
          
		$('#phrases_title').text('Psukim for Names (' + r.length + ')');
          return r;
                          // clicking on play
          }).catch((error) => {
            if (requestGeneration === quoteLetterRequestGeneration) container.setAttribute('aria-busy', 'false');
            console.warn(error.message);
            return [];
          });
  return rawResponse;
        }
